import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=70daac60&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielkaschlaw/Desktop/Sites/devTools_shit/35627/35/easygroundVueTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70daac60')) {
      api.createRecord('70daac60', component.options)
    } else {
      api.reload('70daac60', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=70daac60&", function () {
      api.rerender('70daac60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/pageDesign/Carousel.vue"
export default component.exports